<script setup lang="ts">
import { defineEmits } from "vue";

const emit = defineEmits(["close-popup"]);
function closePopup() {
  emit("close-popup");
}

const isLinkCopied = ref(false);
const copyLink = () => {
  const urlToCopy = window.location.href;
  navigator.clipboard
    .writeText(urlToCopy)
    .then(() => {
      console.log("Ссылка скопирована в буфер обмена:", urlToCopy);
      isLinkCopied.value = true;
    })
    .catch((err) => {
      console.error("Ошибка копирования ссылки:", err);
    });
};

const openWhatsapp = () => {
  const whatsappUrl = `https://api.whatsapp.com/send/?text=${encodeURIComponent(
    window.location.href
  )}`;
  window.open(whatsappUrl, "_blank");
};
const openTelegram = () => {
  const telegramUrl = `https://telegram.me/share/url?url=${encodeURIComponent(
    window.location.href
  )}`;
  window.open(telegramUrl, "_blank");
};
const openFacebook = () => {
  const facebookUrl = `https://www.facebook.com/sharer.php?src=sp&u=${encodeURIComponent(
    window.location.href
  )}`;
  window.open(facebookUrl, "_blank");
};
const openClassmates = () => {
  const ClassmatesUrl = `https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=${encodeURIComponent(
    window.location.href
  )}`;
  window.open(ClassmatesUrl, "_blank");
};
const openVK = () => {
  const vkUrl = `https://vk.com/share.php?url=${encodeURIComponent(
    window.location.href
  )}`;
  window.open(vkUrl, "_blank");
};

const handleClickOutside = (event) => {
  if (!event.target.closest(".closePopup")) {
    closePopup();
  }
};
</script>
<template>
  <Body class="!max-h-screen !max-w-screen !overflow-hidden"></Body>
  <div
    class="flex fixed z-50 bg-black bg-opacity-50 top-0 left-0 bottom-0 right-0 justify-center px-4"
    @click="handleClickOutside"
  >
    <div
      class="closePopup bg-white m-auto rounded-2xl py-8 sm:py-12 md:py-17 px-3 xs:px-6 sm:px-16 md:px-25 relative flex"
    >
      <div class="grid gap-6 xs:gap-10">
        <div class="flex justify-start sm:justify-center">
          <p
            class="text-xl xs:text-2xl sm:text-3xl px-auto font-semibold font-lato"
          >
            Поделиться
          </p>
        </div>

        <div
          class="py-3 px-3 xs:px-8 sm:px-20 rounded-lg"
          style="box-shadow: 0px 4px 20px 0px #48507029"
        >
          <div class="flex gap-6 sm:gap-8">
            <div @click="openWhatsapp">
              <p-icon-watsapp-share></p-icon-watsapp-share>
            </div>
            <div @click="openTelegram">
              <p-icon-telegram-share></p-icon-telegram-share>
            </div>
            <div @click="openFacebook">
              <p-icon-facebook-share></p-icon-facebook-share>
            </div>
            <div @click="openClassmates">
              <p-icon-classmates-share></p-icon-classmates-share>
            </div>
            <div @click="openVK">
              <p-icon-vk-share></p-icon-vk-share>
            </div>
          </div>
        </div>
        <button
          @click="copyLink"
          class="py-2 px-5 flex rounded-full hover:bg-primary-500 bg-primary-300 items-center place-content-center gap-4"
          style="box-shadow: 0px 4px 20px 0px #48507029"
        >
          <p-icon-copy></p-icon-copy>
          <p v-if="!isLinkCopied" class="text-white">Скопировать ссылку</p>
          <p v-else class="text-white">Скопировано</p>
        </button>
      </div>
      <button
        class="absolute w-6 h-6 top-8 sm:top-10 right-6 sm:right-10"
        @click="closePopup"
      >
        <svg
          class="h-4 xs:h-6 w-4 xs:w-6"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 23L12 12.0001M12 12.0001L23 1M12 12.0001L1 1M12 12.0001L23 23"
            stroke="#BDC1D4"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
</template>
